var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
import { Dropdown } from '../ts/tools/Dropdown';
import { AjaxLoader } from './AjaxLoader';
export class Filters extends Component {
    constructor() {
        super('Filters', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const buttonToggleFilters = $('.button-toggle-filters');
            if (buttonToggleFilters.length > 0) {
                const filterDropdown = new Dropdown($('.filters').get(0));
                buttonToggleFilters.on('click', (event) => {
                    event.preventDefault();
                    buttonToggleFilters.toggleClass('active');
                    filterDropdown.toggle();
                    if (buttonToggleFilters.hasClass('active')) {
                        $('.button-close-filters').removeClass('d-none');
                    }
                    else {
                        $('.button-close-filters').addClass('d-none');
                    }
                });
                $('.button-close-filters').on('click', () => {
                    buttonToggleFilters.removeClass('active');
                    filterDropdown.slideUp();
                    $('.button-close-filters').addClass('d-none');
                });
                FWP.auto_refresh = false;
                $('body').on('click', '.facetwp-radio, .facetwp-checkbox', (event, oldButton) => {
                    if (AjaxLoader.isItemOpened) {
                        $('.font-editor .button-close').trigger('click');
                    }
                    setTimeout(() => {
                        FWP.refresh();
                    }, 50);
                });
                $(document).on('facetwp-loaded', function () {
                    let selectedFacetCount = 0;
                    Object.entries(FWP.facets).forEach(([key, value]) => {
                        selectedFacetCount += value.length;
                    });
                    if (selectedFacetCount > 0) {
                        buttonToggleFilters.addClass('active');
                        filterDropdown.slideDown();
                    }
                });
            }
            const buttonDisplayList = $('.button-display-list');
            buttonDisplayList.on('click', (event) => {
                event.preventDefault();
                buttonDisplayList.addClass('active');
                buttonDisplayGrid.removeClass('active');
                $('.preview').removeClass('col-8').addClass('col-16');
            });
            const buttonDisplayGrid = $('.button-display-grid');
            buttonDisplayGrid.on('click', (event) => {
                event.preventDefault();
                buttonDisplayList.removeClass('active');
                buttonDisplayGrid.addClass('active');
                $('.preview').removeClass('col-16').addClass('col-8');
            });
            this.success();
        });
    }
}
